
import MapService from '@services/map.service';
import {
    GET_MAP,
    SET_MAP,
    UPDATE_MAP_FIELD,
    PUBLISH_MAP,
    SET_PUBLISHED,
    RENAME_MAP,
    DELETE_MAP,
    APPROVE_MAP,
    SET_MAP_APPROVALS,
    DISAPPROVE_MAP,
    SET_MAP_APPROVAL,
    ADD_MAP_COMMENT,
    RESOLVE_MAP_COMMENT,
    REMOVE_MAP_COMMENT,
    DELETE_MAP_COMMENT
} from './actions';
import {UPDATE_CHILD_MAP} from '../child/actions';
import Vue from 'vue';

const state = {
    map: {}
};

const mutations = {
    [SET_MAP](state, map) {
        state.map = map;
        if (!state.map.comments) {
            Vue.set(state.map, 'comments', []);
        }
    },
    [ADD_MAP_COMMENT](state, comment) {
        if (!state.map.comments) {
            Vue.set(state.map, 'comments', []);
        }
        state.map.comments.push(comment);
        Vue.set(state.map, 'comments_count', (state.map.comments_count || 0) + 1);
    },
    [RESOLVE_MAP_COMMENT](state, payload) {
        const comment = typeof payload === 'object' && payload !== null ? payload : {id: payload};
        if (!state.map.comments) {
            Vue.set(state.map, 'comments', []);
        }
        if (comment.resolved_at || comment.deleted_at) {
            const removeIndex = state.map.comments.findIndex(c => c.id == comment.id);
            if (removeIndex !== -1) {
                Vue.delete(state.map.comments, removeIndex);
                Vue.set(state.map, 'comments_count', Math.max((state.map.comments_count || 0) - 1, 0));
            }
            return;
        }
        const index = state.map.comments.findIndex(c => c.id == comment.id);
        if (index === -1) {
            state.map.comments.push(comment);
            Vue.set(state.map, 'comments_count', (state.map.comments_count || 0) + 1);
        } else {
            Vue.set(state.map.comments, index, comment);
        }
    },
    [REMOVE_MAP_COMMENT](state, payload) {
        if (!state.map.comments) {
            return;
        }
        const commentId = typeof payload === 'object' && payload !== null ? payload.id : payload;
        const index = state.map.comments.findIndex(c => c.id == commentId);
        if (index !== -1) {
            Vue.delete(state.map.comments, index);
            Vue.set(state.map, 'comments_count', Math.max((state.map.comments_count || 0) - 1, 0));
        }
    },
    [SET_PUBLISHED](state, published) {
        state.map.published = published;
    },
    [UPDATE_MAP_FIELD](state, field) {
        const index = state.map.data.findIndex(f => f.field_id === field.field_id && f.employee_id === field.employee_id);

        if(index !== -1) {
            Vue.set(state.map.data, index, field);
        } else {
            state.map.data.push(field);
        }
    },
    [DELETE_MAP](state) {
        state.map = {};
    },
    [SET_MAP_APPROVALS](state, approvals) {
        state.map.approvals = approvals;
    },
    [SET_MAP_APPROVAL](state, approval) {
        if(!state.map.approvals) {
            state.map.approvals = [approval];
        } else {
            const index = state.map.approvals.findIndex(a => a.created_by === approval.created_by);
            if(index !== -1) {
                Vue.set(state.map.approvals, index, approval);
            } else {
                state.map.approvals.push(approval);
            }
        }
    }
};
const actions = {
    [GET_MAP]({commit, getters}, {childId, mapId}) {
        return MapService.getMap(getters.activeKindergartenId, childId, mapId).then(res => {
            commit(SET_MAP, res);
        });
    },
    [UPDATE_MAP_FIELD]({commit, getters}, {childId, mapId, data}) {
        return MapService.updateField(getters.activeKindergartenId, childId, mapId, data).then(res => {
            //commit(UPDATE_MAP_FIELD, res);
            if(res.approvals) {
                commit(SET_MAP_APPROVALS, res.approvals);
            }
        });
    },
    [ADD_MAP_COMMENT]({commit, getters}, comment) {
        return MapService.addComment(getters.activeKindergartenId, getters.currentMap.child_id, getters.currentMap.id, comment).then(res => {
            commit(ADD_MAP_COMMENT, res);
            return res;
        });
    },
    [RESOLVE_MAP_COMMENT]({commit, getters}, commentId) {
        return MapService.resolveComment(getters.activeKindergartenId, getters.currentMap.child_id, getters.currentMap.id, commentId).then(res => {
            commit(RESOLVE_MAP_COMMENT, res);
        });
    },
    [DELETE_MAP_COMMENT]({commit, getters}, commentId) {
        return MapService.deleteComment(getters.activeKindergartenId, getters.currentMap.child_id, getters.currentMap.id, commentId).then(() => {
            commit(REMOVE_MAP_COMMENT, commentId);
        });
    },
    [PUBLISH_MAP]({commit, getters}, {childId, mapId, form}) {
        return MapService.publishMap(getters.activeKindergartenId, childId, mapId, form).then(res => {
           commit(SET_PUBLISHED, res.published);
        });
    },
    [RENAME_MAP]({commit, getters},  {childId, mapId, form}) {
        return MapService.renameMap(getters.activeKindergartenId, childId, mapId, form).then(res => {
            commit(UPDATE_CHILD_MAP, res);
        });
    },
    [DELETE_MAP]({commit, getters}, {childId, mapId}) {
        return MapService.deleteMap(getters.activeKindergartenId, childId, mapId).then(res => {
            commit(DELETE_MAP, res);
        });
    },
    [APPROVE_MAP]({commit, getters}, {mapId, childId, form}) {
        return MapService.approveMap(getters.activeKindergartenId, childId, mapId, form).then(res => {
            commit(SET_MAP_APPROVALS, res);
        });
    },
    [DISAPPROVE_MAP]({commit, getters}, {mapId, childId, form}) {
        return MapService.disapproveMap(getters.activeKindergartenId, childId, mapId, form).then(res => {
            commit(SET_MAP_APPROVALS, res);
        });
    }
};
const getters = {
    currentMap: state => {
        return state.map;
    },
    currentMapComments: state => {
        return state.map.comments || [];
    }
};

export default {
    state,
    mutations,
    actions,
    getters
};
